import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from '../lib/react-query';

import axios from 'axios';

export type VVPTestConfig = {
  AudioMode: string;
  ControlMode: string;
  FixationAssist: boolean;
  Layout: string;
  LayoutType: string;
  TestDurationLimitSec: number;
  TestEyes: string;
  TutorialEnabled: boolean;
};

export type SetTestConfigResponse = {
  success?: string;
  error?: string;
  test_config?: VVPTestConfig;
};

export type SetTestConfigDTO = {
  clinic_user_id: number;
  test_config: VVPTestConfig;
};

export const setTestConfig = ({
  clinic_user_id,
  test_config,
}: SetTestConfigDTO): Promise<SetTestConfigResponse> => {
  return axios.post('/vue_api/set_test_config', {
    clinic_user_id: clinic_user_id,
    test_config: test_config,
  });
};

type UseSetTestConfigOptions = {
  config?: MutationConfig<typeof setTestConfig>;
};

export const useSetVVPTestConfig = ({ config }: UseSetTestConfigOptions = {}) => {
  return useMutation({
    onMutate: async (data) => {
      await queryClient.cancelQueries('testConfigs');

      const previousTestConfig = queryClient.getQueryData<VVPTestConfig>([
        'testConfigs',
        data.clinic_user_id,
      ]);

      queryClient.setQueryData('testConfigs', data.clinic_user_id);

      return { previousTestConfig };
    },
    onError: (_, __, context: any) => {
      if (context?.previousUsers) {
        queryClient.setQueryData('testConfigs', context.previousUsers);
      }
    },
    onSuccess: (data, vars) => {
      queryClient.invalidateQueries(['testConfigs', vars.clinic_user_id]);
    },
    ...config,
    mutationFn: setTestConfig,
  });
};
